"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLinkButton = exports.StyledLinkButtonWrapper = exports.StyledLinkButtonContent = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const getHeight_1 = require("./helpers/getHeight");
const StackView_1 = require("../../StackView");
const Text_1 = require("../../Text");
exports.StyledLinkButtonContent = styled_components_1.default.span `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
exports.StyledLinkButtonWrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    height: ${({ compact }) => (0, getHeight_1.getHeight)(compact)};
    max-width: 100%;
`;
exports.StyledLinkButton = (0, styled_components_1.default)(Text_1.Text) `
    padding: 0;
    margin: 0;
    border: none;
    background: none;
    flex-shrink: 0;
    display: inline-flex;
    line-height: ${({ compact }) => (0, getHeight_1.getHeight)(compact)};
    cursor: default;
    text-overflow: ellipsis;
    outline: none;

    ${({ disabled }) => !disabled &&
    (0, styled_components_1.css) `
            cursor: pointer;

            &:hover,
            &:focus,
            &:active {
                outline: none;
                text-decoration: underline;
            }
        `}
`;
//# sourceMappingURL=LinkButton.styles.js.map